import script from "./Staking.vue?vue&type=script&setup=true&lang=ts"
export * from "./Staking.vue?vue&type=script&setup=true&lang=ts"

import "./Staking.vue?vue&type=style&index=0&id=5187102d&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5187102d"]])

export default __exports__